import { calculateDistance } from "./calculateDistance";

/** Parse a km value; 0 / blank / NaN are treated as unknown. */
export function parseDistanceKm(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

export function getUserCoords(user) {
  try {
    const saved = localStorage.getItem("userSetAddress");
    if (saved) {
      const parsed = JSON.parse(saved);
      const lat =
        parsed.lat != null ? parseFloat(parsed.lat) : parseFloat(parsed.latitude);
      const lng =
        parsed.lng != null ? parseFloat(parsed.lng) : parseFloat(parsed.longitude);
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return { lat, lng };
      }
    }
  } catch (e) {
    // ignore malformed localStorage
  }

  const addr =
    user && user.success && user.data && user.data.default_address
      ? user.data.default_address
      : null;
  if (addr && addr.latitude != null && addr.longitude != null) {
    const lat = parseFloat(addr.latitude);
    const lng = parseFloat(addr.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return { lat, lng };
    }
  }

  return null;
}

/**
 * Canonical customer↔store km for the store page, cart, checkout, and place-order.
 * Prefer backend road distance (Google Routes API on restaurant.distance),
 * then any already-computed cart km, then Haversine as last resort.
 * Do not use Google Distance Matrix here — that diverged from the store pill.
 */
export function resolveStoreDistanceKm(restaurant, extraDistance, user) {
  const fromStore = parseDistanceKm(restaurant && restaurant.distance);
  if (fromStore != null) return fromStore;

  const fromExtra = parseDistanceKm(extraDistance);
  if (fromExtra != null) return fromExtra;

  if (
    !restaurant ||
    restaurant.latitude == null ||
    restaurant.longitude == null
  ) {
    return null;
  }

  const loc = getUserCoords(user);
  if (!loc) return null;

  try {
    const km = calculateDistance(
      parseFloat(restaurant.longitude),
      parseFloat(restaurant.latitude),
      loc.lng,
      loc.lat
    );
    return Number.isFinite(km) && km > 0 ? km : null;
  } catch (e) {
    return null;
  }
}
